/* ==========================================================================
   CASA FLORES — seletor de entrega da página da peça (calendário)
   16/10/2026 · arquivo novo, carregado DEPOIS do app (v58 em /products, v56
   em /pages/produto). Não substitui nada do app: só escreve nos controles que
   o app já lê.

   O CONTRATO QUE NÃO PODE QUEBRAR (app v58, linhas ~1595-1677):
   · o app lê `input[data-pdp-data].value` (ISO AAAA-MM-DD) no clique de
     "Pôr na sacola", e valida no 'change' (mínimo amanhã pela hora LOCAL do
     navegador, domingo recusado: limpa o campo);
   · o app guarda a janela numa variável INTERNA, que só muda pelo CLIQUE nos
     `[data-janela]`. Clicar no botão já ativo DESMARCA (vira 'a combinar').
   Este componente, portanto:
   · escreve o ISO no input e dispara 'input' + 'change' (o handler do app
     roda a validação de sempre; não depende de isTrusted);
   · clica no botão real da janela SÓ se ele ainda não está aria-pressed=true;
   · confere depois do 'change' se o app manteve a data. Se o relógio do
     aparelho estiver num dia diferente do de São Paulo, o app pode limpar o
     campo: aí o componente AVISA, não finge que gravou.

   MELHORIA PROGRESSIVA. Sem [data-pdp-data]/[data-pdp-janela], ou sem Intl
   com fuso horário, nada acontece e os controles nativos continuam lá. Os
   nativos só somem (classe `cal-pronto` no contêiner) depois que o gatilho
   está montado — e continuam no DOM, porque o app depende deles.

   ES5, IIFE, sem dependência.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- config
     Regras de entrega REAIS da casa. Nada aqui é inventado: não há preço por
     período, expressa, hora marcada, retirada nem horário de corte. */
  var TZ = 'America/Sao_Paulo';
  var DIAS_FECHADOS = [0];          /* 0 = domingo. A casa não entrega no domingo. */
  /* Feriados e datas sem entrega QUE A CASA INFORMAR, formato 'AAAA-MM-DD'.
     Vazio de propósito: nenhum feriado está cadastrado hoje. */
  var DATAS_BLOQUEADAS = [];
  var ANTECEDENCIA_DIAS = 1;        /* entrega a partir do dia seguinte ao pedido */
  var HORIZONTE_DIAS = 90;          /* agenda: de amanhã até hoje + 90 */
  var BREAKPOINT = '(min-width: 900px)';  /* o mesmo ponto em que a PDP vira 2 colunas */
  var NOTAS = [
    'A casa confirma o horário com você depois do pedido.',
    'Entrega própria na Vila Olímpia e região. Por conta da casa a partir de R$ 450.'
  ];
  /* As JANELAS não estão aqui: são lidas dos próprios botões [data-janela]. */

  var SEM = 'sem-preferencia';

  /* ------------------------------------------------------------- pt-BR */
  var DIAS_CURTOS  = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
  var DIAS_LONGOS  = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira',
                      'quinta-feira', 'sexta-feira', 'sábado'];
  var DIAS_PLURAL  = ['domingos', 'segundas-feiras', 'terças-feiras', 'quartas-feiras',
                      'quintas-feiras', 'sextas-feiras', 'sábados'];
  var DIAS_GATILHO = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
  var MESES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho',
               'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
  var FRASE_JANELA = { 'Manhã': 'pela manhã', 'Tarde': 'à tarde' };

  var TXT = {
    rotulo: 'Data e período de entrega',
    vazio: 'Escolha o dia e o período',
    alterar: 'Alterar',
    titulo: 'Dia e período da entrega',
    fechar: 'Fechar',
    resumoData: 'Data escolhida',
    resumoDataVazio: 'Escolha no calendário',
    resumoPeriodo: 'Período',
    resumoPeriodoVazio: 'Escolha um período',
    mesAnterior: 'Mês anterior',
    proximoMes: 'Próximo mês',
    legSel: 'Selecionada', legLivre: 'Disponível', legSem: 'Sem entrega',
    periodo: 'Período',
    semPreferencia: 'Sem preferência',
    semPreferenciaApoio: 'A casa combina o horário com você.',
    aCombinar: 'Horário a combinar',
    confirmar: 'Confirmar entrega',
    faltaData: 'Escolha o dia da entrega.',
    faltaPeriodo: 'Escolha manhã, tarde ou sem preferência.',
    faltaDois: 'Escolha o dia e o período.',
    diaRecusado: 'Esse dia não está disponível. Escolha outro.',
    semEntrega: 'Sem entrega neste dia.'
  };

  /* ------------------------------------------------------- utilidades */
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function temIntl() {
    try {
      if (typeof Intl === 'undefined' || !Intl.DateTimeFormat) return false;
      var f = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' });
      return typeof f.formatToParts === 'function' && f.formatToParts(new Date()).length > 0;
    } catch (e) { return false; }
  }

  /* DIA CIVIL. Uma data é um inteiro: dias desde 1970-01-01, contados em UTC.
     Toda conta (somar dia, dia da semana, comparar) acontece em UTC puro, que
     não tem horário de verão nem fuso, então nenhum dia "escorrega" por causa
     do relógio do aparelho. */
  var DIA_MS = 86400000;
  function num(y, m, d) { return Math.round(Date.UTC(y, m - 1, d) / DIA_MS); }
  function partes(n) {
    var dt = new Date(n * DIA_MS);
    return { y: dt.getUTCFullYear(), m: dt.getUTCMonth() + 1, d: dt.getUTCDate() };
  }
  function semana(n) { return new Date(n * DIA_MS).getUTCDay(); }
  function diasNoMes(y, m) { return new Date(Date.UTC(y, m, 0)).getUTCDate(); }
  function iso(n) { var p = partes(n); return p.y + '-' + pad(p.m) + '-' + pad(p.d); }
  function deIso(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s || ''));
    if (!m) return null;
    var y = +m[1], mo = +m[2], d = +m[3];
    if (mo < 1 || mo > 12 || d < 1 || d > diasNoMes(y, mo)) return null;
    return num(y, mo, d);
  }
  function somaMeses(n, k) {
    var p = partes(n);
    var t = p.y * 12 + (p.m - 1) + k;
    var y = Math.floor(t / 12), m = t % 12 + 1;
    return num(y, m, Math.min(p.d, diasNoMes(y, m)));
  }
  function chaveMes(y, m) { return y * 12 + (m - 1); }

  /* "HOJE" É O DE SÃO PAULO, não o do relógio local. `window.CF_CAL_AGORA`
     ('AAAA-MM-DDTHH:mm', hora de parede em São Paulo) existe só para o
     harness de teste simular o relógio. */
  function hojeSP() {
    var teste = window.CF_CAL_AGORA;
    if (teste) {
      var t = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(teste));
      if (t) return num(+t[1], +t[2], +t[3]);
    }
    var ps = new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(new Date());
    var o = {};
    for (var i = 0; i < ps.length; i++) o[ps[i].type] = ps[i].value;
    return num(+o.year, +o.month, +o.day);
  }

  /* ------------------------------------------------------- textos de data */
  function mesTitulo(y, m) { var s = MESES[m - 1]; return s.charAt(0).toUpperCase() + s.slice(1) + ' de ' + y; }
  function dataLonga(n) { var p = partes(n); return p.d + ' de ' + MESES[p.m - 1] + ' de ' + p.y; }
  function dataCurta(n) { var p = partes(n); return p.d + ' de ' + MESES[p.m - 1]; }

  /* ================================================================ início */
  function inicia() {
    var campoData = $('[data-pdp-data]');
    var cxJanela = $('[data-pdp-janela]');
    if (!campoData || !cxJanela) return;
    if (campoData.hasAttribute('data-cal-ligado')) return;
    if (!temIntl()) return;            /* sem Intl com fuso: fica o input nativo */

    var botoesJanela = $$('[data-janela]', cxJanela);
    if (!botoesJanela.length) return;
    var JANELAS = botoesJanela.map(function (b) {
      var v = b.getAttribute('data-janela');
      return { valor: v, rotulo: (b.textContent || '').replace(/\s+/g, ' ').replace(/^\s|\s$/g, '') || v };
    });

    var blocoData = campoData.closest ? (campoData.closest('.campo') || campoData.parentNode) : campoData.parentNode;
    var blocoJanela = cxJanela.closest ? (cxJanela.closest('.campo') || cxJanela) : cxJanela;
    var conteiner = (campoData.closest && (campoData.closest('.compra') || campoData.closest('form'))) || blocoData.parentNode;

    /* Peça sob consulta: o app esconde os blocos com style.display='none'
       ANTES deste arquivo rodar. Sem linha de pedido, sem seletor. */
    function nativoEscondido() { return blocoData.style.display === 'none'; }
    if (nativoEscondido()) return;

    campoData.setAttribute('data-cal-ligado', '');
    var bloqueadas = {};
    DATAS_BLOQUEADAS.forEach(function (s) { if (deIso(s) !== null) bloqueadas[s] = true; });

    var hoje = hojeSP();

    /* "AMANHÃ" DO APP. O app valida pelo relógio LOCAL e calcula o amanhã UMA
       vez, no carregamento, e o escreve em `campoData.min`. Se o aparelho está
       num fuso à frente de SP e já virou o dia, esse amanhã é mais tarde que o
       de SP: o calendário respeita o mais tardio dos dois, para nunca oferecer
       um dia que o handler do app vai limpar. Em SP os dois coincidem. */
    var amanhaApp = deIso(campoData.min);
    if (amanhaApp === null) {
      var dl = new Date();
      amanhaApp = num(dl.getFullYear(), dl.getMonth() + 1, dl.getDate()) + 1;
    }

    function janelaAtual() {
      for (var i = 0; i < botoesJanela.length; i++) {
        if (botoesJanela[i].getAttribute('aria-pressed') === 'true') return botoesJanela[i].getAttribute('data-janela');
      }
      return '';
    }
    function botaoJanela(v) {
      for (var i = 0; i < botoesJanela.length; i++) {
        if (botoesJanela[i].getAttribute('data-janela') === v) return botoesJanela[i];
      }
      return null;
    }
    function rotuloJanela(v) {
      for (var i = 0; i < JANELAS.length; i++) if (JANELAS[i].valor === v) return JANELAS[i].rotulo;
      return v;
    }
    function rotuloPeriodo(p) { return p === SEM ? TXT.semPreferencia : rotuloJanela(p); }

    function estado(n) {
      if (n === hoje) return 'hoje';
      if (n < hoje) return 'passado';
      if (n < hoje + ANTECEDENCIA_DIAS) return 'cedo';
      if (n < amanhaApp) return 'cedo';
      if (n > hoje + HORIZONTE_DIAS) return 'fora';
      if (DIAS_FECHADOS.indexOf(semana(n)) !== -1) return 'fechado';
      if (bloqueadas[iso(n)]) return 'bloqueado';
      return 'livre';
    }
    function primeiroLivre() {
      for (var n = hoje + 1; n <= hoje + HORIZONTE_DIAS; n++) if (estado(n) === 'livre') return n;
      return hoje + ANTECEDENCIA_DIAS;
    }
    function limites() {
      var ph = partes(hoje), pf = partes(hoje + HORIZONTE_DIAS);
      return {
        minFoco: num(ph.y, ph.m, 1),
        maxFoco: num(pf.y, pf.m, diasNoMes(pf.y, pf.m)),
        minMes: chaveMes(ph.y, ph.m),
        maxMes: chaveMes(pf.y, pf.m),
        fim: hoje + HORIZONTE_DIAS
      };
    }
    function textoFimAgenda() { return 'A agenda vai até ' + dataLonga(limites().fim) + '.'; }

    /* ================================================= GATILHO NA PÁGINA */
    var ajudaNativa = $('.campo__aj', blocoData);
    var textoAjuda = ajudaNativa ? (ajudaNativa.textContent || '').replace(/\s+/g, ' ').replace(/^\s|\s$/g, '') : '';

    var campo = document.createElement('div');
    campo.className = 'campo cal-campo';
    campo.setAttribute('data-cal-campo', '');
    campo.innerHTML =
      '<button type="button" class="cal-gatilho cal-gatilho--vazio" aria-haspopup="dialog" ' +
        'aria-controls="cal-dialogo" data-cal-abre' + (textoAjuda ? ' aria-describedby="cal-ajuda"' : '') + '>' +
        '<svg class="cal-gatilho__ico" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" ' +
          'stroke-width="1.5" aria-hidden="true" focusable="false"><path d="M3 5h14v12H3V5Z"/><path d="M3 9h14"/>' +
          '<path d="M7 3v4M13 3v4"/></svg>' +
        '<span class="cal-gatilho__txt">' +
          '<span class="cal-gatilho__r">' + esc(TXT.rotulo) + '<span class="cal-sr">, </span></span>' +
          '<span class="cal-gatilho__v" data-cal-valor>' + esc(TXT.vazio) + '</span>' +
        '</span>' +
        '<span class="cal-gatilho__acao" data-cal-acao></span>' +
      '</button>' +
      (textoAjuda ? '<p class="campo__aj cal-campo__aj" id="cal-ajuda">' + esc(textoAjuda) + '</p>' : '') +
      '<p class="cal-campo__aviso" role="status" data-cal-aviso></p>' +
      '<p class="cal-sr" aria-live="polite" aria-atomic="true" data-cal-anuncio-pdp></p>';
    blocoData.parentNode.insertBefore(campo, blocoData);

    var gatilho = $('[data-cal-abre]', campo);
    var gValor = $('[data-cal-valor]', campo);
    var gAcao = $('[data-cal-acao]', campo);
    var gAviso = $('[data-cal-aviso]', campo);
    var gAnuncio = $('[data-cal-anuncio-pdp]', campo);

    var CHEVRON = '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M8 4l6 6-6 6"/></svg>';

    function textoGatilhoData(n) {
      var p = partes(n), ph = partes(hoje);
      return DIAS_GATILHO[semana(n)] + ', ' + p.d + ' de ' + MESES[p.m - 1] + (p.y !== ph.y ? ' de ' + p.y : '');
    }

    function pintaGatilho() {
      var n = deIso(campoData.value);
      var j = janelaAtual();
      var escolha = gatilho.getAttribute('data-escolha');
      if (n === null) {
        gatilho.removeAttribute('data-escolha');
        gatilho.classList.add('cal-gatilho--vazio');
        gValor.textContent = TXT.vazio;
        gAcao.innerHTML = CHEVRON;
        return;
      }
      var per = j ? rotuloJanela(j) : (escolha === SEM ? TXT.aCombinar : '');
      gatilho.classList.remove('cal-gatilho--vazio');
      gValor.innerHTML = '<span>' + esc(textoGatilhoData(n)) + '</span>' +
        (per ? '<span class="cal-gatilho__sep" aria-hidden="true">&#8201;·&#8201;</span>' +
               '<span class="cal-sr">, </span><span>' + esc(per) + '</span>' : '');
      gAcao.innerHTML = '<span class="cal-sr">, </span><span class="cal-gatilho__alterar">' + esc(TXT.alterar) + '</span>';
    }

    function avisaGatilho(t) { gAviso.textContent = t || ''; }

    function anunciaEm(regiao, t) {
      regiao.textContent = '';
      setTimeout(function () { regiao.textContent = t; }, 60);
    }

    /* ======================================================== O DIÁLOGO */
    var veu = $('[data-veu]');
    if (!veu) {
      veu = document.createElement('div');
      veu.className = 'veu cal-veu';
      veu.setAttribute('data-veu', '');
      document.body.appendChild(veu);
    }

    var opcoes = JANELAS.map(function (j) { return { valor: j.valor, rotulo: j.rotulo, apoio: '' }; });
    opcoes.push({ valor: SEM, rotulo: TXT.semPreferencia, apoio: TXT.semPreferenciaApoio });

    var dlg = document.createElement('aside');
    dlg.className = 'cal';
    dlg.id = 'cal-dialogo';
    dlg.setAttribute('role', 'dialog');
    dlg.setAttribute('aria-modal', 'true');
    dlg.setAttribute('aria-labelledby', 'cal-t');
    dlg.innerHTML =
      '<div class="cal__cab">' +
        '<h2 class="cal__t" id="cal-t">' + esc(TXT.titulo) + '</h2>' +
        '<button type="button" class="cal__fecha" data-cal-fecha aria-label="' + esc(TXT.fechar) + '">' +
          '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" ' +
          'aria-hidden="true" focusable="false"><path d="M5 5l10 10M15 5L5 15"/></svg></button>' +
      '</div>' +
      '<div class="cal__resumo">' +
        '<div class="cal__res">' +
          '<p class="cal__res-r">' + esc(TXT.resumoData) + '</p>' +
          '<p class="cal__res-v" data-cal-res-data></p>' +
          '<p class="cal__res-s" data-cal-res-semana></p>' +
        '</div>' +
        '<div class="cal__res">' +
          '<p class="cal__res-r">' + esc(TXT.resumoPeriodo) + '</p>' +
          '<p class="cal__res-v" data-cal-res-periodo></p>' +
        '</div>' +
      '</div>' +
      '<div class="cal__rolo">' +
        '<div class="cal__corpo">' +
          '<div class="cal__mesbloco">' +
            '<div class="cal__nav">' +
              '<button type="button" class="cal__seta" data-cal-ant aria-label="' + esc(TXT.mesAnterior) + '">' +
                '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" ' +
                'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 4l-6 6 6 6"/></svg></button>' +
              '<h3 class="cal__mes" id="cal-mes" aria-live="polite"></h3>' +
              '<button type="button" class="cal__seta" data-cal-prox aria-label="' + esc(TXT.proximoMes) + '">' +
                '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" ' +
                'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M8 4l6 6-6 6"/></svg></button>' +
            '</div>' +
            '<table class="cal__grade" role="grid" aria-labelledby="cal-mes">' +
              '<thead><tr>' + DIAS_CURTOS.map(function (d, i) {
                return '<th scope="col" abbr="' + DIAS_LONGOS[i].replace('-feira', '') + '">' + d + '</th>';
              }).join('') + '</tr></thead>' +
              '<tbody data-cal-dias></tbody>' +
            '</table>' +
            '<div class="cal__legenda" aria-hidden="true">' +
              '<span class="cal__leg"><span class="cal__amostra cal__amostra--sel">8</span>' + esc(TXT.legSel) + '</span>' +
              '<span class="cal__leg"><span class="cal__amostra">8</span>' + esc(TXT.legLivre) + '</span>' +
              '<span class="cal__leg"><span class="cal__amostra cal__amostra--sem">8</span>' + esc(TXT.legSem) + '</span>' +
            '</div>' +
          '</div>' +
          '<div class="cal__filete" aria-hidden="true"></div>' +
          '<div class="cal__lado">' +
            '<fieldset class="cal__periodos">' +
              '<legend class="cal__periodos-r">' + esc(TXT.periodo) + '</legend>' +
              opcoes.map(function (o, i) {
                return '<label class="cal__op" data-cal-op="' + esc(o.valor) + '">' +
                  '<input class="cal__radio" type="radio" name="cal-periodo" value="' + esc(o.valor) + '">' +
                  '<span class="cal__caixa" aria-hidden="true"></span>' +
                  '<span class="cal__op-txt"><span class="cal__op-n">' + esc(o.rotulo) + '</span>' +
                    (o.apoio ? '<span class="cal__op-a">' + esc(o.apoio) + '</span>' : '') +
                  '</span>' +
                '</label>';
              }).join('') +
            '</fieldset>' +
            '<div class="cal__notas">' + NOTAS.map(function (t) { return '<p>' + esc(t) + '</p>'; }).join('') + '</div>' +
            '<div class="cal__vaga" data-cal-vaga-desk></div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="cal__pe" data-cal-pe>' +
        '<div class="cal__acao" data-cal-acao-bloco>' +
          '<p class="cal__aviso" role="status" data-cal-aviso-dlg></p>' +
          '<button type="button" class="btn btn--primaria btn--bloco cal__confirma" data-cal-confirma aria-disabled="true">' +
            esc(TXT.confirmar) + '</button>' +
        '</div>' +
      '</div>' +
      '<p class="cal-sr" aria-live="polite" aria-atomic="true" data-cal-anuncio></p>';
    document.body.appendChild(dlg);

    var elDias = $('[data-cal-dias]', dlg);
    var elMes = $('#cal-mes', dlg);
    var elAnt = $('[data-cal-ant]', dlg);
    var elProx = $('[data-cal-prox]', dlg);
    var elFecha = $('[data-cal-fecha]', dlg);
    var elConfirma = $('[data-cal-confirma]', dlg);
    var elAvisoDlg = $('[data-cal-aviso-dlg]', dlg);
    var elAnuncio = $('[data-cal-anuncio]', dlg);
    var elResData = $('[data-cal-res-data]', dlg);
    var elResSemana = $('[data-cal-res-semana]', dlg);
    var elResPeriodo = $('[data-cal-res-periodo]', dlg);
    var elPe = $('[data-cal-pe]', dlg);
    var elVagaDesk = $('[data-cal-vaga-desk]', dlg);
    var elAcao = $('[data-cal-acao-bloco]', dlg);
    var radios = $$('.cal__radio', dlg);

    /* O botão de confirmar mora no PÉ FIXO no celular e no FUNDO DA COLUNA de
       períodos no computador. Um botão só, que muda de lugar: dois botões
       iguais dariam duas paradas de Tab e duas verdades de estado. */
    var mq = window.matchMedia ? window.matchMedia(BREAKPOINT) : null;
    function posicionaAcao() {
      var desk = mq && mq.matches;
      (desk ? elVagaDesk : elPe).appendChild(elAcao);
      elPe.hidden = !!desk;
    }
    posicionaAcao();
    if (mq) {
      if (mq.addEventListener) mq.addEventListener('change', posicionaAcao);
      else if (mq.addListener) mq.addListener(posicionaAcao);
    }

    /* --------------------------------------------------------- rascunho */
    var st = { aberto: false, mes: 0, foco: 0, data: null, periodo: '' };

    function mesDe(n) { var p = partes(n); return chaveMes(p.y, p.m); }

    function rotuloCelula(n, e) {
      var base = DIAS_LONGOS[semana(n)] + ', ' + dataLonga(n);
      switch (e) {
        case 'hoje': return 'hoje, ' + base + ', entrega no mesmo dia só pelo WhatsApp';
        case 'passado': return base + ', data passada';
        case 'fechado': return base + ', sem entrega aos ' + DIAS_PLURAL[semana(n)];
        case 'fora': return base + ', fora da agenda';
        case 'livre': return base + (st.data === n ? ', escolhido' : '');
        default: return base + ', sem entrega neste dia';
      }
    }

    function pintaMes() {
      var lim = limites();
      var y = Math.floor(st.mes / 12), m = st.mes % 12 + 1;
      var primeiro = num(y, m, 1), total = diasNoMes(y, m), off = semana(primeiro);
      var ultimo = primeiro + total - 1;
      if (st.foco < primeiro || st.foco > ultimo) {
        /* mesmo dia do mês no mês exibido (ou o último dia, se não existir) */
        st.foco = num(y, m, Math.min(partes(st.foco).d, total));
      }
      st.foco = Math.min(Math.max(st.foco, lim.minFoco), lim.maxFoco);
      var semanas = Math.ceil((off + total) / 7);
      var html = '';
      for (var w = 0; w < semanas; w++) {
        html += '<tr>';
        for (var c = 0; c < 7; c++) {
          var i = w * 7 + c - off;
          if (i < 0 || i >= total) { html += '<td class="cal__vazio"></td>'; continue; }
          var n = primeiro + i, e = estado(n), sel = st.data === n;
          var cls = 'cal__dia ' + (e === 'livre' ? 'cal__dia--livre' : 'cal__dia--sem') +
                    (e === 'hoje' ? ' cal__dia--hoje' : '') + (sel ? ' cal__dia--sel' : '');
          html += '<td role="gridcell" class="' + cls + '" data-n="' + n + '" data-iso="' + iso(n) + '"' +
            ' tabindex="' + (n === st.foco ? '0' : '-1') + '"' +
            ' aria-selected="' + (sel ? 'true' : 'false') + '"' +
            (e !== 'livre' ? ' aria-disabled="true"' : '') +
            (e === 'hoje' ? ' aria-current="date"' : '') +
            ' aria-label="' + esc(rotuloCelula(n, e)) + '">' +
            '<span class="cal__chapa" aria-hidden="true">' + (i + 1) + '</span></td>';
        }
        html += '</tr>';
      }
      elDias.innerHTML = html;
      var t = mesTitulo(y, m);
      if (elMes.textContent !== t) elMes.textContent = t;

      var antOff = st.mes <= lim.minMes, proxOff = st.mes >= lim.maxMes;
      elAnt.setAttribute('aria-disabled', antOff ? 'true' : 'false');
      elProx.setAttribute('aria-disabled', proxOff ? 'true' : 'false');
      if (proxOff) elProx.setAttribute('title', textoFimAgenda()); else elProx.removeAttribute('title');
    }

    function celulaFoco() { return $('td[data-n="' + st.foco + '"]', elDias); }
    function focaCelula() { var c = celulaFoco(); if (c) c.focus(); }

    function pintaResumo() {
      if (st.data !== null) {
        var p = partes(st.data), ph = partes(hoje);
        elResData.innerHTML = esc(p.d + ' de ' + MESES[p.m - 1]) +
          '<span class="cal__ano' + (p.y === ph.y ? ' cal__ano--corrente' : '') + '"> de ' + p.y + '</span>';
        elResData.classList.remove('cal__res-v--vazio');
        elResSemana.textContent = DIAS_LONGOS[semana(st.data)].replace('-feira', '');
        elResSemana.hidden = false;
      } else {
        elResData.textContent = TXT.resumoDataVazio;
        elResData.classList.add('cal__res-v--vazio');
        elResSemana.textContent = '';
        elResSemana.hidden = true;
      }
      if (st.periodo) {
        elResPeriodo.textContent = rotuloPeriodo(st.periodo);
        elResPeriodo.classList.remove('cal__res-v--vazio');
      } else {
        elResPeriodo.textContent = TXT.resumoPeriodoVazio;
        elResPeriodo.classList.add('cal__res-v--vazio');
      }
    }

    function pintaPeriodos() {
      radios.forEach(function (r) {
        r.checked = r.value === st.periodo;
        var lab = r.closest ? r.closest('.cal__op') : r.parentNode;
        if (lab) lab.classList.toggle('cal__op--marcado', r.checked);
      });
    }

    function pintaBotao() {
      elConfirma.setAttribute('aria-disabled', (st.data !== null && st.periodo) ? 'false' : 'true');
    }

    /* A região role=status fica sempre na árvore (o CSS não usa display:none).
       Mesma mensagem duas vezes não muda o texto e não seria relida: limpa e
       reescreve. */
    function avisaDlg(t) {
      if (t && elAvisoDlg.textContent === t) { anunciaEm(elAvisoDlg, t); return; }
      elAvisoDlg.textContent = t || '';
    }
    function anuncia(t) { anunciaEm(elAnuncio, t); }

    /* ------------------------------------------------------ navegação */
    function vaiPara(n) {
      var lim = limites();
      n = Math.min(Math.max(n, lim.minFoco), lim.maxFoco);
      st.foco = n;
      var novoMes = mesDe(n);
      if (novoMes !== st.mes) { st.mes = novoMes; }
      pintaMes();
      focaCelula();
    }

    function trocaMes(k) {
      var lim = limites();
      var alvo = st.mes + k;
      if (alvo < lim.minMes || alvo > lim.maxMes) {
        if (k > 0) anuncia(textoFimAgenda());
        return;
      }
      st.foco = Math.min(Math.max(somaMeses(st.foco, k), lim.minFoco), lim.maxFoco);
      st.mes = alvo;
      pintaMes();
    }

    function escolheDia(n) {
      if (estado(n) !== 'livre') { anuncia(TXT.semEntrega); return; }
      st.data = n;
      st.foco = n;
      pintaMes();
      focaCelula();
      pintaResumo();
      pintaBotao();
      avisaDlg('');
      anuncia('Data escolhida: ' + DIAS_LONGOS[semana(n)] + ', ' + dataCurta(n) + '.');
    }

    elDias.addEventListener('click', function (ev) {
      var td = ev.target.closest ? ev.target.closest('td[data-n]') : null;
      if (!td) return;
      var n = +td.getAttribute('data-n');
      st.foco = n;
      if (estado(n) !== 'livre') {
        $$('td[tabindex="0"]', elDias).forEach(function (x) { x.setAttribute('tabindex', '-1'); });
        td.setAttribute('tabindex', '0');
        td.focus();
        anuncia(TXT.semEntrega);
        return;
      }
      escolheDia(n);
    });

    elDias.addEventListener('keydown', function (ev) {
      var f = st.foco, alvo = null;
      switch (ev.key) {
        case 'ArrowLeft': case 'Left': alvo = f - 1; break;
        case 'ArrowRight': case 'Right': alvo = f + 1; break;
        case 'ArrowUp': case 'Up': alvo = f - 7; break;
        case 'ArrowDown': case 'Down': alvo = f + 7; break;
        case 'Home': alvo = f - semana(f); break;
        case 'End': alvo = f + (6 - semana(f)); break;
        case 'PageUp': alvo = somaMeses(f, ev.shiftKey ? -12 : -1); break;
        case 'PageDown': alvo = somaMeses(f, ev.shiftKey ? 12 : 1); break;
        case 'Enter': case ' ': case 'Spacebar':
          ev.preventDefault();
          escolheDia(f);
          return;
        default: return;
      }
      ev.preventDefault();
      vaiPara(alvo);
    });

    elAnt.addEventListener('click', function () { trocaMes(-1); });
    elProx.addEventListener('click', function () { trocaMes(1); });

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        st.periodo = r.value;
        pintaPeriodos();
        pintaResumo();
        pintaBotao();
        avisaDlg('');
        anuncia('Período: ' + rotuloPeriodo(r.value).toLowerCase() + '.');
      });
    });

    /* ------------------------------------------------------- gravar */
    function dispara(el, tipo) {
      var ev;
      try { ev = new Event(tipo, { bubbles: true }); }
      catch (e) { ev = document.createEvent('Event'); ev.initEvent(tipo, true, false); }
      el.dispatchEvent(ev);
    }

    function grava(n, periodo) {
      var alvo = iso(n);
      var anterior = campoData.value;
      campoData.value = alvo;
      dispara(campoData, 'input');
      dispara(campoData, 'change');
      /* O app limpa o campo quando recusa o dia pela conta dele (relógio
         local). Valor diferente depois do 'change' = recusado. Devolve a
         escolha anterior (já aceita pelo app, cujo "amanhã" é fixo), para a
         linha do carrinho e o gatilho continuarem iguais. */
      if (campoData.value !== alvo) {
        campoData.value = anterior;
        dispara(campoData, 'input');
        dispara(campoData, 'change');
        return 'data';
      }

      var desejado = periodo === SEM ? '' : periodo;
      var atual = janelaAtual();
      if (desejado !== atual) {
        if (desejado) {
          var b = botaoJanela(desejado);
          if (b && b.getAttribute('aria-pressed') !== 'true') b.click();
        } else {
          var ba = botaoJanela(atual);
          if (ba && ba.getAttribute('aria-pressed') === 'true') ba.click();   /* desmarca: o app grava 'a combinar' */
        }
      }
      if (janelaAtual() !== desejado) return 'janela';
      gatilho.setAttribute('data-escolha', periodo === SEM ? SEM : periodo);
      return '';
    }

    elConfirma.addEventListener('click', function () {
      hoje = hojeSP();
      if (st.data === null || !st.periodo) {
        if (st.data === null && !st.periodo) avisaDlg(TXT.faltaDois);
        else if (st.data === null) avisaDlg(TXT.faltaData);
        else avisaDlg(TXT.faltaPeriodo);
        if (st.data === null) focaCelula();
        else radios[0].focus();
        return;
      }
      if (estado(st.data) !== 'livre') {     /* a página ficou aberta e o dia virou */
        st.data = null;
        pintaMes(); pintaResumo(); pintaBotao();
        avisaDlg(TXT.diaRecusado);
        focaCelula();
        return;
      }
      var n = st.data, periodo = st.periodo;
      var erro = grava(n, periodo);
      if (erro === 'data') {
        st.data = null;
        pintaMes(); pintaResumo(); pintaBotao();
        avisaDlg(TXT.diaRecusado);
        pintaGatilho();          /* mostra a escolha anterior, que foi devolvida ao campo */
        focaCelula();
        return;
      }
      if (erro === 'janela') {
        avisaDlg(TXT.faltaPeriodo);
        avisaGatilho(TXT.faltaPeriodo);
        pintaGatilho();
        radios[0].focus();
        return;
      }
      avisaGatilho('');
      pintaGatilho();
      fecha();
      var frase = periodo === SEM ? 'com horário a combinar'
        : (FRASE_JANELA[periodo] || FRASE_JANELA[rotuloJanela(periodo)] || rotuloJanela(periodo).toLowerCase());
      anunciaEm(gAnuncio, 'Entrega marcada para ' + DIAS_LONGOS[semana(n)] + ', ' + dataCurta(n) + ', ' + frase + '.');
    });

    /* --------------------------------------------- abrir e fechar
       O MESMO PADRÃO DAS GAVETAS DO TEMA (app, `abre`/`fecha`): véu, rolagem
       do body travada, irmãos do body inertes, Tab preso, Esc fecha, foco
       volta ao gatilho. Não usa o `abre()` do app porque ele é privado e o
       confirmar precisa fechar DEPOIS de gravar. O diálogo é filho direto do
       body, então o "inerte em todo irmão" funciona igual. */
    var inertesPostos = [];
    var overflowAntes = '';

    function abre() {
      if (st.aberto) return;
      if (document.querySelector('.gaveta[data-aberto]')) return;   /* outra gaveta do tema aberta */
      hoje = hojeSP();
      avisaDlg('');

      /* O rascunho começa pela escolha CONFIRMADA (o que está no contrato). */
      var n = deIso(campoData.value);
      st.data = (n !== null && estado(n) === 'livre') ? n : null;
      var j = janelaAtual();
      st.periodo = j || (st.data !== null && gatilho.getAttribute('data-escolha') === SEM ? SEM : '');
      st.foco = st.data !== null ? st.data : primeiroLivre();
      st.mes = mesDe(st.foco);

      pintaMes(); pintaResumo(); pintaPeriodos(); pintaBotao();

      st.aberto = true;
      dlg.setAttribute('data-cal-aberto', '');
      veu.setAttribute('data-aberto', '');
      overflowAntes = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      inertesPostos = [];
      $$('body > *').forEach(function (el) {
        if (el === dlg || el === veu || el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'LINK') return;
        if (el.hasAttribute('inert')) return;
        el.setAttribute('inert', '');
        el.setAttribute('aria-hidden', 'true');
        inertesPostos.push(el);
      });
      gatilho.setAttribute('aria-expanded', 'true');
      focaCelula();
      setTimeout(function () { if (st.aberto && !dlg.contains(document.activeElement)) focaCelula(); }, 30);
    }

    function fecha() {
      if (!st.aberto) return;
      st.aberto = false;
      dlg.removeAttribute('data-cal-aberto');
      veu.removeAttribute('data-aberto');
      document.body.style.overflow = overflowAntes;
      inertesPostos.forEach(function (el) {
        el.removeAttribute('inert');
        el.removeAttribute('aria-hidden');
      });
      inertesPostos = [];
      gatilho.setAttribute('aria-expanded', 'false');
      gatilho.focus();
    }

    gatilho.addEventListener('click', abre);
    elFecha.addEventListener('click', fecha);       /* fechar sem confirmar descarta o rascunho */
    veu.addEventListener('click', function () { if (st.aberto) fecha(); });

    document.addEventListener('keydown', function (ev) {
      if (!st.aberto) return;
      if (ev.key === 'Escape' || ev.key === 'Esc') { ev.preventDefault(); fecha(); return; }
      if (ev.key !== 'Tab') return;
      /* Primeira parada: o X. Última: o Confirmar (no celular ele está no pé,
         no computador no fim da coluna — nos dois casos é o último do DOM). */
      var ativo = document.activeElement;
      if (!dlg.contains(ativo)) { ev.preventDefault(); elFecha.focus(); return; }
      if (ev.shiftKey && ativo === elFecha) { ev.preventDefault(); elConfirma.focus(); }
      else if (!ev.shiftKey && ativo === elConfirma) { ev.preventDefault(); elFecha.focus(); }
    });

    /* ------------------------------------------------ montar e esconder */
    /* Defesa extra: o `max` não muda formato nem handler do app. */
    try { campoData.max = iso(limites().fim); } catch (e) { /* navegador sem max */ }

    blocoData.setAttribute('data-cal-nativo', '');
    blocoJanela.setAttribute('data-cal-nativo', '');
    gatilho.setAttribute('aria-expanded', 'false');
    pintaGatilho();
    conteiner.classList.add('cal-pronto');

    /* Se o app esconder o bloco DEPOIS (sob consulta), o gatilho some junto. */
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (nativoEscondido()) { campo.style.display = 'none'; if (st.aberto) fecha(); }
      }).observe(blocoData, { attributes: true, attributeFilter: ['style'] });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicia);
  else inicia();
})();
